import * as React from 'react';
import OriginalButton from '../../Button';
import styled from 'styled-components';
const InputButton = (props) => React.createElement(OriginalButton, { ...props });
export default styled(InputButton) ``;
